// extracted by mini-css-extract-plugin
export default {"container":"add-product-input_container__whVr6","delete-icon":"add-product-input_delete-icon__7ITgN"};